import {Component, OnInit, OnDestroy, ViewEncapsulation, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {ConfigService} from '../config/config.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UserNameCommunication} from '../service/userNameCommunication.service';
import {LanguageService} from '../service/language.service';
import {PopupComponent} from '../popup/popup.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MyAccountComponent implements OnInit, OnDestroy {
  popupButtonsNotVsible = '';
  popupText = '';

  constructor(private api: ConfigService, private router: Router, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private userNameCommunication: UserNameCommunication, private _language: LanguageService, public dialog: MatDialog) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }
  sideNavComponents = [{
    id: 0,
    name: '',
  }];
  user: any;
  isLoaderVisible = false;
  mainTab = 0;
  artTab = 0;
  accountTab = 0;

  changeMainTab(event: any): void {
    this.mainTab = event;
    this.accountTab = 0;
    this.artTab = 0;
  }
  changeSecondaryTabArt(event: any): void {
    this.artTab = event;
  }
  changeSecondaryTabAccount(event: any): void {
    this.accountTab = event;
    if ((this.user.role_id === 2 || this.user.role_id === 3) && event === 3) {
      this.logOut();
    } else {
      if (event === 2) {
        this.logOut();
      }
    }
  }

  async createAccount(): Promise<void> {
    this.sideNavComponents = [
      {
        id: 0,
        name: 'myArt',
      },
      {
        id: 1,
        name: 'offers',
      },
      {
        id: 2,
        name: 'myAccount',
      },
      {
        id: 3,
        name: 'loadedArt',
      },
      {
        id: 4,
        name: 'addArt',
      },
      {
        id: 5,
        name: 'accountDetails',
      },
      {
        id: 6,
        name: 'payment',
      },
      {
        id: 7,
        name: 'termsAndConditionsAccount',
      },
      {
        id: 8,
        name: 'logOut',
      },
    ];
    console.log('sideNavComponents', this.sideNavComponents);
  }

  getUserInfo(): void {
    this.api.getLoggedUser().subscribe(
      user => {
        if (user) {
          this.user = user;
          this.createAccount();
        }
        this.isLoaderVisible = false;
      }, error => {
        console.log('error', error);
        // todo
        this.isLoaderVisible = false;
        this.router.navigate(['Login']);
        // this.user = {
        //   id: 15,
        //   first_name: 'Lupu',
        //   last_name: 'Andreea-Monica',
        //   email: 'andreeamonica.lupu@gmail.com',
        //   phone_number: '0740241423',
        //   agreed_term_conditions: 1,
        //   agreed_contacted_via_mail: 0,
        //   agreed_contacted_via_phone: 1,
        //   role_id: 2,
        //   created_at: '2024-08-05T07:03:37.000000Z',
        //   updated_at: '2024-09-26T07:57:54.000000Z',
        //   full_name: 'Lupu Andreea-Monica',
        //   role: {
        //     id: 2,
        //     role_name: 'Artist',
        //     created_at: null,
        //     updated_at: null
        //   }
        // };
        // this.isLoaderVisible = false;
        // this.createAccount();
      });
  }

  // tslint:disable-next-line:typedef
  translateLabel(label: string) {
    return label;
  }
  logOut(): void {
    this.translate.get('sureYouWantToLogOut').subscribe(message => {
      const dialogRef = this.dialog.open(PopupComponent, {
        data: {popupText: message, popupButtonsNotVsible: 'nu'},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true){
          localStorage.removeItem('token');
          this.router.navigate(['/']);
        } else {
          this.accountTab = 0;
        }
      });
    });
  }
  ngOnInit(): void {
    this.getUserInfo();
  }

  ngOnDestroy(): void {
    this.userNameCommunication.updateUserName('');
  }

}
